export default "__VITE_ASSET__DYYbOF$9__"